var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-cover rounded-lg",class:{
        'w-32 h-48': _vm.size == 'big',
        'w-12 h-20': _vm.size == 'small'
    },style:({ backgroundImage: ("url(/img/love-letter/" + _vm.role + ".jpg)") })})}
var staticRenderFns = []

export { render, staticRenderFns }